import React, {useCallback, useEffect, useState} from "react";
import {BiPlus} from "react-icons/bi";
import {FiSearch} from "react-icons/fi";
import {useHistory, useRouteMatch, useParams} from "react-router-dom";
import BlockCustomDialog from "./BlockCustomDialog";
import _ from "lodash";
import {IoIosCloseCircleOutline, IoMdArrowBack} from "react-icons/io";
import {AiOutlineDelete} from "react-icons/ai";
import {MdOutlineCheckBox, MdOutlineCheckBoxOutlineBlank} from "react-icons/md";
import PropTypes from "prop-types";
import {useMutation} from "react-query";
import {deleteAssignment, getAssignmentList} from "../../api/assignment";

const CheckBoxControl = ({checked, onChange}) => {
    return !checked ? (
        <MdOutlineCheckBoxOutlineBlank
            onClick={() => onChange(!checked)}
            size={20}
            color={"#000"}
            className="mr-2 cursor-pointer"
        />
    ) : (
        <MdOutlineCheckBox
            size={20}
            onClick={() => onChange(!checked)}
            color={"#000"}
            className="mr-2 cursor-pointer"
        />
    );
};

export default function BlockAssignmentList() {
    const { classId } = useParams();
    const history = useHistory();
    const [searching, setSearching] = useState(false);
    const [isOpen, setOpen] = useState(false);
    const [deleteBox, _deleteBox] = useState(false);
    const [playListTitle, _playListTitle] = useState('');
    const [assignmentList, _assignmentList] = useState([]);
    const [selecting, setSelecting] = useState(false);
    const [errorMsg, _errorMsg] = useState('');
    const {url} = useRouteMatch();

    /** create the back URL*/
    const splitData = url.split('/')
    const backUrl = splitData.slice(0, 4).join('/');

    const isAnySelected = assignmentList.some(playlist => playlist.isSelected)

    /** call the Api to fetch the assignment list*/
    const fetAssignmentList = (title = '', page = 0, size = 5) => {
        getAssignmentList(title, page, size).then(res => {
            const assignmentData = res.data.body;
            const data = assignmentData.map((item) => {
                return {
                    ...item,
                    isSelected: false
                }
            })
            _assignmentList(data);
        }).catch(error => {
            console.log("Get Assignment List Error", error);
        });
    }

    /** start  fetch assignment list function */
    useEffect(() => {
        fetAssignmentList();
    }, []);

    /** toggle the select and unselect*/
    const toggleSelecting = () => setSelecting(!selecting);

    /** function used to select the particular play list*/
    const toggleSelection = (checked, index) => {
        const newPlayLists = assignmentList.map((playlist, i) => {
            if (i === index) return {...playlist, isSelected: checked};
            return playlist;
        });
        _assignmentList(newPlayLists);
    };


    /** search handler change*/
    const changeHandler = event => {
        const title = event.target.value;
        if (title?.trim() !== '') {
            getAssignmentList(title).then(res => {
                const data = res.data.body;
                _assignmentList(data);
            }).catch(error => console.log("Search using title Error", error))
        } else {
            fetAssignmentList();
        }
    };


    /** debounce function used to submit the search value after some delay*/
    const debouncedChangeHandler = useCallback(_.debounce(changeHandler, 300), []);

    /** filter the selected list*/
    const filterSelectedList = () => {
        const filter = assignmentList.filter((item) => item.isSelected === true);
        return filter;
    }

    /** update the assignment list*/
    const {
        mutate: updateTheAssignment,
    } = useMutation('', {
        onSuccess: (data, variables) => {
            alert("Assignment updated Successfully");
        },
        onError: (err) => {
            console.log(err);
            alert("Something Went wrong...");
        },
    });

    /** delete the assignment list*/
    const {
        mutate: deleteTheAssignment,
    } = useMutation(deleteAssignment, {
        onSuccess: (data, variables) => {
            fetAssignmentList();
            _deleteBox(false);
        },
        onError: (err) => {
            console.log(err);
            alert("Something Went wrong...");
        },
    });

    //using the function delete the selected assignment
    const removeAssignment = () => {
        const filterList = filterSelectedList();
        if (filterList?.length > 0) {
            deleteTheAssignment(filterList);
        }
    }

    /** assignment delete warning dialog box*/
    const closeDialogBox = () => {
        _deleteBox(false)
        const data = assignmentList.map((item) => {
            return {
                ...item,
                isSelected: false
            }
        });
        _assignmentList(data);
    }

    /** go to upload assignment page*/
    const goToAddAssignment = () => {
        history.push(backUrl);
    }

    /** go to assignment edit page*/
    const goToEditAssignment = (data) => {

        history.push({
            pathname: `${backUrl}/edit-assignment`,
            state: {
                assignmentData: data
            }
        })
    }
    const goToAssignmentList = () => {
        history.push(`${backUrl}/assignment-lists`);
    }
    return (
        <>
            <div className="bg-[#F7F7F7] rounded-lg assignmentListWrapper">
                <div className="flex item-center border-b border-b-black gap-x-2">
                    {searching ? (
                        <input
                            type="text"
                            className="bg-transparent w-full px-4 outline-0"
                            placeholder="Search"
                            onChange={debouncedChangeHandler}
                        />
                    ) : (
                        <h4 className="text-xl flex-auto cursor-pointer" onClick={() => setSearching(true)}>Your
                            Content</h4>
                    )}
                    <FiSearch
                        size={20}
                        className="cursor-pointer"
                        onClick={() => setSearching(true)}
                    />
                    <BiPlus
                        size={20}
                        className="cursor-pointer"
                        onClick={() => goToAddAssignment()}
                    />
                </div>
                <div className="flex flex-col flex-auto justify-between ">
                    <div className="flex-auto ">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center mt-3">
                                <IoMdArrowBack
                                    onClick={() => history.push(`${backUrl}`)}
                                    size={30}
                                    className="mr-3 cursor-pointer"
                                />
                                <i className="icon icon-"></i>
                                <h4 className="text-xl flex-auto">{errorMsg !== '' ?
                                    <div className="flex justify-center items-center gap-2">
                                        <span className="text-red-600 underline">{errorMsg}</span> <span
                                        className="cursor-pointer rotate-45"
                                        onClick={() => _errorMsg('')}>
                                        <i className="icon icon-plus-circle text-xl"></i></span>
                                    </div> : 'All Assignments'}</h4>
                            </div>
                            <div className="flex items-center gap-x-3">
                                <button
                                    onClick={toggleSelecting}
                                    className="font-bold text-base font-[Poppins-Bold]"
                                >
                                    {selecting ? "Cancel" : "Select"}
                                </button>
                                {
                                    isAnySelected && selecting &&
                                    <button
                                        onClick={() => {
                                            _deleteBox(true);
                                        }}
                                        className="font-bold text-lg font-[Poppins-Bold]"
                                    >
                                        <AiOutlineDelete size={25}/>
                                    </button>
                                }
                            </div>
                        </div>

                        <ul className="block assignmentList">
                            {assignmentList?.map((item, index) => (
                                <li
                                    key={"playlist_" + index}
                                    className="flex items-center justify-between py-3"
                                >
                                    <div className="flex items-center">
                                        {selecting ? (
                                            <CheckBoxControl
                                                checked={item.isSelected}
                                                onChange={(checked) => toggleSelection(checked, index)}
                                            />
                                        ) : null}
                                        <p className="text-lg">{item?.title}</p>
                                    </div>
                                    <button
                                        onClick={() => goToEditAssignment(item)}
                                        className="underline text-base"
                                    >
                                        Edit
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
            <div className="assignment-list-footer">
                <div>
                    <span
                        onClick={() => goToAssignmentList()}
                    >View Assignments</span>
                    {/* <button
                        type="button"
                        className="w-20 h-8  text-black text-gray-400  browseBtn">
                        cancel
                    </button> */}
                    <button
                        type="submit"
                        className="w-20 h-8 text-black font-[Poppins-Bold] browseBtn"
                        onClick={() => history.push(`/teacher/${classId}/create-class-plan`)}
                    >
                        next
                    </button> 
                </div>
            </div>

            {/** add new Assignment to list*/}
            <BlockCustomDialog
                targetId="contentWrapperBox"
                open={isOpen}
                onClose={() => setOpen(false)}
                overlayClasses="justify-center items-center backdrop-blur-md"
            >
                <div className="w-96 flex flex-col rounded-full p-4">
                    <h4 className="text-xl text-center font-medium">
                        {errorMsg !== '' ?
                            <div className="flex justify-between items-center">
                                <span className="text-red-600">{errorMsg}</span>
                                <IoIosCloseCircleOutline onClick={() => _errorMsg('')}/>
                            </div> : <span>Add New Assignment</span>}
                    </h4>
                    <div className="mb-6">
                        <input
                            type="text"
                            placeholder="Give your Assignment name"
                            className="text-sm text-center w-full bg-neutral-100 py-4 px-2 my-2 not-italic"
                            onChange={(e) => _playListTitle(e.target.value)}
                        />
                    </div>
                    <button
                        className="w-30 mx-auto px-10 py-2 text-white bg-black font-extrabold font-[Poppins-Bold] rounded-lg">
                        Add
                    </button>
                </div>
            </BlockCustomDialog>

            {/** delete a assignment */}
            <BlockCustomDialog
                targetId="contentWrapperBox"
                open={deleteBox}
                onClose={() => _deleteBox(false)}
                overlayClasses="justify-center items-center backdrop-blur-md"
            >
                <div className="w-96 flex flex-col rounded-full p-4">
                    <h4 className="text-lg font-bold text-center">
                        Delete Assignment
                    </h4>
                    <div className="mt-3 mb-6">
                        <p className="text-center px-4">
                            Are you sure you want to delete this
                            Assignment_1 and Assignment_2?
                        </p>
                    </div>
                    <div className="flex gap-x4">
                        <button
                            onClick={() => removeAssignment()}
                            className="w-40 mx-auto px-10 py-2 text-black border-2 border-black font-extrabold font-[Poppins-Bold] rounded-lg">
                            Yes
                        </button>
                        <button
                            onClick={closeDialogBox}
                            className="w-40 mx-auto px-10 py-2 text-white bg-black font-extrabold font-[Poppins-Bold] rounded-lg">
                            No
                        </button>
                    </div>
                </div>
            </BlockCustomDialog>
        </>
    );
}
CheckBoxControl.propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func
}
